import { SHOPIFY_APP_PROXY_LOGIN_URL } from '../api';

async function establishSecureStoreSession() {
  console.log('Attempting to establish secure store session...');
  try {
    const payload = {};

    const response = await fetch(`${SHOPIFY_APP_PROXY_LOGIN_URL}/store-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      credentials: 'include' // Still crucial for cookie exchange
    });

    const data = await response.json();

    if (response.ok) {
      console.log('Secure store session:', data.message);
    } else {
      console.error('Failed to establish secure store session:', data.message);
    }
  } catch (error) {
    console.error('Network or unexpected error during secure store session establishment:', error);
  }
}

// Starts at module load; await it before any proxy call (avoids first-visit 401s).
export const storeSessionReady = establishSecureStoreSession();
